var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c("div", [
        _c("div", { staticClass: "dashboard-block" }, [
          _c("h2", [_vm._v("Request Status")]),
          _vm._v(" "),
          _c("div", { staticClass: "booking-progress-steps" }, [
            _c("div", { staticClass: "alert alert-success alert-icon" }, [
              _c("i", { staticClass: "fa fa-check-circle" }),
              _vm._v(
                "\n        Congrats! Your " +
                  _vm._s(_vm.$t("request")) +
                  " has been submitted\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-icon",
                class: _vm.alertClassRequestIsVetted,
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.iconClassRequestIsVetted,
                }),
                _vm._v(
                  "\n        Your " +
                    _vm._s(_vm.$t("request")) +
                    " is being vetted by the " +
                    _vm._s(_vm.clientName) +
                    " team, we’ll be in touch shortly\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-icon",
                class: _vm.alertClassTalentReviewingRequest,
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.iconClassTalentReviewingRequest,
                }),
                _vm._v(
                  "\n        Talent are reviewing your " +
                    _vm._s(_vm.$t("request")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert alert-icon",
                class: _vm.alertClassTalentChosen,
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.iconClassTalentChosen,
                }),
                _vm._v(
                  "\n        Choose your talent from list of applicants\n      "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.bookingTypeIsBookingRequest && _vm.bookingHasExpired
          ? _c("div", { staticClass: "alert alert-danger alert-icon" }, [
              _c("i", { staticClass: "fa fa-frown-o" }),
              _vm._v(" "),
              _vm.bookingHaveNoAppliedTalent
                ? _c("span", [
                    _vm._v(
                      "\n      You did not have any responses in time. Feel free to change your request or contact the " +
                        _vm._s(_vm.clientName) +
                        " team for advice.\n    "
                    ),
                  ])
                : _c("span", [
                    _vm._v(
                      "\n      Unfortunately your booking has expired. Contact the " +
                        _vm._s(_vm.clientName) +
                        " team for advice.\n    "
                    ),
                  ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }